import {
  type UnknownAction,
  combineReducers,
  createAction,
} from "@reduxjs/toolkit";

import policyReducer from "./policySlice";
import searchReducer from "./searchSlice";
import shopReducer from "./shopSlice";

export const resetExchange = createAction("exchange/reset");

const baseFlightExchangeReducer = combineReducers({
  policy: policyReducer,
  search: searchReducer,
  shop: shopReducer,
});

/**
 * If the state given to it is undefined, it must return the initial state for this specific reducer.
 * source: https://redux.js.org/api/combinereducers
 */
export const initialState = baseFlightExchangeReducer(undefined, { type: "" });

export const flightExchangeReducer = (state, action: UnknownAction) => {
  if (action.type === resetExchange.type) {
    return baseFlightExchangeReducer(undefined, action);
  }

  return baseFlightExchangeReducer(state, action);
};

export type FlightExchangeState = ReturnType<typeof flightExchangeReducer>;
